import { z } from "zod";

export const LiabilityRateType = z.enum(["Payroll", "Receipts", "Other"]);

export type LiabilityRateTypeEnum = z.infer<typeof LiabilityRateType>;

export const LiabilityRateTypeDisplayName: Record<
  LiabilityRateTypeEnum,
  string
> = {
  [LiabilityRateType.enum.Payroll]: "Payroll",
  [LiabilityRateType.enum.Receipts]: "Receipts",
  [LiabilityRateType.enum.Other]: "Other",
};
